(function ClientsPotential($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/ClientsPotential/index', function onload()
		{
			$('.num-match').each(function checkMatches() {
				var request_id = $(this).data("id");

				Adzuki.Ajax.get('/ClientsPotential/getCount/' + request_id)
				.then(function success(data) {
					$('#matched-' + request_id).html(data.count);
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
